import gql from 'graphql-tag';

const TEAMS = gql`
  query teams(
    $where: TeamWhereInput
    $orderBy: TeamOrderByInput
    $first: Int
    $skip: Int
  ) {
    teams(where: $where, orderBy: $orderBy, first: $first, skip: $skip) {
      id
      name
      description
      org {
        id
        name
      }
      members {
        id
        name
        username
        avatar {
          id
          key
        }
        roles {
          id
          roleItems {
            feature
          }
        }
      }
      subscribers {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      subscribedTeams {
        id
        name
        members {
          id
          name
          username
          avatar {
            id
            key
          }
        }
      }
      subscriberTeams {
        id
        name
        members {
          id
          name
          username
          avatar {
            id
            key
          }
        }
      }
      leader {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      tasks {
        id
        assigneeUser {
          id
        }
        assigneeUsers {
          id
        }
      }
      createdBy {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

export default TEAMS;
